import { useForm, zodResolver } from '@mantine/form';
import { z } from 'zod';

import { DeclarationDocumentsEnum } from '@e-origin/shared';

export const customerSchema = z.object({
  name: z.string().optional().nullable(),
});
export type CustomerViewFormValues = z.infer<typeof customerSchema>;

export const useCustomerViewFormInitializer = ({ generalDeclarant, customerDetails }) => {
  const buildFormValues = (gd, cd) => ({
    name: cd?.name || '',
    declarant: {
      name: gd?.name || '',
      identificationNumber: gd?.identificationNumber || '',
      identificationNumberIDMS: '',
      useImporterEORI: false,
      address: {
        street: gd?.address?.street || '',
        postcode: gd?.address?.postcode || '',
        city: gd?.address?.city || '',
        country: gd?.address?.country || '',
      },
      authorisedIdentity: gd?.authorisedIdentity || '',
      contactPerson: {
        name: gd?.contactPerson?.name || '',
        phoneNumber: gd?.contactPerson?.phoneNumber || '',
        email: gd?.contactPerson?.email || '',
      },
    },
    representative: {
      name: '',
      identificationNumber: '',
      identificationNumberIDMS: '',
      status: '',
      address: {
        street: '',
        postcode: '',
        city: '',
        country: '',
      },
    },
    payments: {
      methodOfPayment: null,
      deferredPayment: '',
      methodOfPaymentVAT: null,
      deferredPaymentVAT: '',
      additionalFiscalReference: [],
    },
    evaluationMethods: {
      evalMethodAIHSCode: {
        range: {
          from: 0,
          to: 0,
        },
        activateMethod: false,
      },
      evalMethodCalculator: {
        marketplaceFees: 0,
        fullfillmentCost: 0,
        storageCost: 0,
        otherCost: 0,
        activateMethod: false,
      },
      evalMethodWebValue: {
        minimumRate: 0,
        activateMethod: false,
      },
      evalMethodIMADBStatisticalValue: {
        minimumRate: 0,
        activateMethod: false,
      },
    },
    personProvidingGuarantee: {
      identificationNumber: '',
    },
    personPayingTheCustomDuty: {
      identificationNumber: '',
    },
    documents: {
      [DeclarationDocumentsEnum.GUARANTEE_DOCUMENTS]: [],
    },
    externalUsers: [],
    transitAuthorisations: [],
    transitGuarantees: [],
  });

  const form = useForm<CustomerViewFormValues>({
    initialValues: buildFormValues(generalDeclarant, customerDetails),
    validate: zodResolver(customerSchema),
    validateInputOnBlur: true,
    onValuesChange: () => {
      form.validate();
    },
  });

  return { form, buildFormValues };
};
